import extractParentTopicStrings from '../extract/extractParentTopicStrings';
import filterTopicStringChild from '../filter/filterTopicStringChild';

/**
 * Optimized array difference - O(n) instead of O(n²)
 */
function arrayDifference<T>(arr1: T[], arr2: T[]): T[] {
  const set2 = new Set(arr2);
  return arr1.filter((item) => !set2.has(item));
}

/**
 * enrich selected topic ids array with their corresponding parent ids (when all children are selected)
 * @param selectedTopicIdsWithoutParent - The selected topic ids in format "category|topic"
 * @param childIds - The child topic ids in format "category|topic"
 * @returns The enriched topic ids including category IDs when all children are selected
 */
export default function enrichTopicWithParent(selectedTopicStrings: string[], childTopicStrings: string[]): string[] {
  // // The function will return a new array of topic ids including all selected leaf ids,
  // // and any parent category id from allTopicIds whose all children are selected.

  // make sure there is no parent here
  const selectedTopicStringsWithoutParent = selectedTopicStrings.filter(filterTopicStringChild);
  const childTopicStringsWithoutParent = childTopicStrings.filter(filterTopicStringChild);

  // Find topic ids that exist in allTopicIds but not in selectedTopicIds
  const unselectedTopicStrings = arrayDifference(childTopicStringsWithoutParent, selectedTopicStringsWithoutParent);

  // // Identify all parent category IDs from selectedTopicIds
  const selectedTopicStringsParent = extractParentTopicStrings(selectedTopicStringsWithoutParent);
  const unselectedTopicStringsParent = extractParentTopicStrings(unselectedTopicStrings);

  // // Remove the ones from unselectedIds from the parentTopicIds
  // // This gives us categories where all children are selected
  const filteredParentTopicIds = arrayDifference(selectedTopicStringsParent, unselectedTopicStringsParent);
  return [...selectedTopicStringsWithoutParent, ...filteredParentTopicIds];
}
